import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import {LoanNotes} from "@app/models/loan-notes";
import { SavingAgreementNotes } from '@app/models/saving-agreement-notes';

@Injectable({
    providedIn: 'root'
})
export class SavingAgreementNotesService extends BaseRestService {

    readonly SAVING_AGREEMENT_NOTE_URL: string = environment.savingUri + '/saving-agreement-notes';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.SAVING_AGREEMENT_NOTE_URL, options);
    }

    getLoanById(id): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.SAVING_AGREEMENT_NOTE_URL + '/' + id, options);
    }

    create(data: LoanNotes): Observable<any> {
        return this.httpClient.post(this.SAVING_AGREEMENT_NOTE_URL, JSON.stringify(data),
            { headers: this.headers });
    }

    update(accountType: LoanNotes): Observable<any> {
        return this.httpClient.put(this.SAVING_AGREEMENT_NOTE_URL + '/' + accountType.id, JSON.stringify(accountType),
            { headers: this.headers });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.SAVING_AGREEMENT_NOTE_URL + "/" + id,
            { headers: this.headers });
    }

    findSavingAgreementNoteParents(savingAgreementNote: SavingAgreementNotes, savingAgreementNotes: Array<SavingAgreementNotes>){
        let items = [];
        if (savingAgreementNote) {
          items.push(savingAgreementNote);
          if (savingAgreementNotes && savingAgreementNotes.length > 0) {
            const parentItem = this.findSavingAgreementNoteById(savingAgreementNote.parentAgreementNoteId, savingAgreementNotes);
            if (parentItem) {
              items = items.concat(this.findSavingAgreementNoteParents(parentItem, savingAgreementNotes));
            }
          }
        }
        return items;
      }

      findSavingAgreementNoteById(id: string, items: Array<SavingAgreementNotes>) {
        if (id) {
          if (items && items.length > 0) {
            var item = items.find((p) => p.id == id);
            if (item) {
              return item;
            }
  
            for (var i = 0; i < items.length; i++) {
              var item = this.findSavingAgreementNoteById(id, items[i].subSavingAgreementNotes);
              if (item) {
                return item;
              }
            }
          }
        }
        return undefined;
    }

}